import React from 'react';
import './ReceiptNotMor.scss';
import { ImageSpacePlanet } from '../../assets/images';
import { TranslationUtils } from '../../utils';

export const ReceiptNotMor: React.FC = () => {
    return (
        <div className="row">
            <div className="col-12 col-md-3">
                <div className="receipt-not-mor-image">
                    <ImageSpacePlanet />
                </div>
            </div>
            <div className="col-12 col-md-9">
                <h4 className={'heading-med-light'}>{TranslationUtils.get('wheres_my_receipt')}</h4>
                <p className={'body-regular'}>{TranslationUtils.get('channel_receipt_note')}</p>
            </div>
        </div>
    );
};
